<template>
    <button class="country-button" @click="$emit('click')">
        <span class="text">
            {{caption}}
        </span>
        <span class="cross"></span>
    </button>
</template>
<script>
export default {
    props: {
        caption: {
            type: String
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.country-button
    $height: 77px
    display: flex
    height: $height
    background: #FFF
    cursor: pointer
    @include media-breakpoint-down($sm)
        height: 50px
    .text
        display: inline-block
        font-weight: 500
        font-size: 20px
        color: #636776
        padding: 0 2.5em
        margin: auto
        @include media-breakpoint-down($md)
            font-size: 17px
        @include media-breakpoint-down($sm)
            padding: 0 1.625em
            font-size: 11px
    .cross
        background: #ff2b2a
        width: $height
        height: $height
        position: relative
        @include media-breakpoint-down($sm)
            height: 50px
            width: 50px
        &:before, &:after
            content: ""
            position: absolute
            display: block
            top: 50%
            left: 50%
            width: 24px
            height: 2px
            background: #FFFFFF
            transform: translateX(-50%) translateY(-50%)
        &:after
            transform: translateX(-50%) translateY(-50%) rotate(90deg)
</style>
